export const pageLayout = {
    detailsPage: 'details-page',
    listPage: 'list-page',
    tabPage: 'tab-page',
} as const;

export type TPageLayout = (typeof pageLayout)[keyof typeof pageLayout];;
